import { Injectable } from '@angular/core';
import { AuthStateService } from './auth-state.service';
import { DomainContextService } from './domain-context.service';

@Injectable({ providedIn: 'root' })
export class TenantGuardService {
  constructor(
    private auth: AuthStateService,
    private domain: DomainContextService
  ) {}

  // Modelo 2: valida se o usuário pertence ao grupo exigido pelo domínio
  get isTenantAllowed(): boolean {
    const expectedGroupId = this.domain.expectedGroupId;

    // Se o domínio não exige grupo específico, libera
    if (!expectedGroupId) return true;

    return this.auth.hasGroup(expectedGroupId);
  }
}
